module.exports = __webpack_public_path__ + "static/img/mortgage-main.3b674a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/mortgage-main.png
// module id = Oaay
// module chunks = 1